import styled from 'styled-components'
import { containerExpanded } from '../../lib/styles/Container'
import { typoHeading2, typoHeading4, typoParagraph, typoParagraphS } from '../../lib/styles/Typography'
import { ImageProps, SizeProps } from './types'

export const StyledWrapper = styled.div`
  ${containerExpanded}
  margin: 4rem auto;
`

export const StyledDisturber = styled.div<SizeProps>`
  background-color: var(--c-theme-3);
  border-radius: 1.5rem;
  padding: ${p => (p.size === 's' ? '2.5rem 3rem' : '4rem')};

  @media screen and (max-width: 1024px) {
    padding: ${p => (p.size === 's' ? '2rem 2.5rem' : '2.5rem')};
  }

  @media screen and (max-width: 768px) {
    padding: ${p => (p.size === 's' ? '2rem' : '2rem')};
  }
`

export const StyledBody = styled.div<ImageProps>`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media screen and (max-width: ${p => (p.image.filename ? '1024px' : '768px')}) {
    gap: 1rem;
    flex-direction: column;
    align-items: flex-start;
  }

  @media screen and (max-width: 576px) {
    align-items: ${p => (p.image.filename ? 'center' : 'unset')};
    text-align: ${p => (p.image.filename ? 'center' : 'unset')};
  }
`

export const StyledBodyMain = styled.div<ImageProps>`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  gap: 1.5rem;

  @media screen and (max-width: 576px) {
    flex-direction: column;
    align-items: ${p => (p.image.filename ? 'center' : 'unset')};
    gap: 1rem;
  }
`

export const StyledImage = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;

  img {
    object-fit: contain;
    width: 4.5rem;
    max-width: 100%;
  }
`

export const StyledText = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--c-theme-invert);
`

export const StyledHeadline = styled.h2<SizeProps & { fontSize?: string }>`
  ${p => (p.size === 's' ? typoHeading4 : typoHeading2)}
  font-size: ${p => p.fontSize || 'unset'};
  margin-bottom: 0.5rem;
`

export const StyledDescription = styled.div<{ fontSize?: string }>`
  ${typoParagraph}
  font-size: ${p => p.fontSize || 'unset'};
`

export const StyledButtons = styled.div<ImageProps>`
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  justify-content: ${p => (p.image.filename ? 'center' : 'unset')};
`

export const StyledFeatureList = styled.div`
  grid-area: feature-list;
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(3, 1fr);
  color: var(--c-theme-invert);
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: solid 2px ${({ theme }) => theme.colors.white[6]};

  @media screen and (max-width: 1024px) {
    gap: 1.5rem;
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 576px) {
    gap: 1rem;
    grid-template-columns: repeat(1, 1fr);
  }
`

export const StyledFeatureListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  ${typoParagraphS}
`

export const StyledDisturberFeatureImage = styled.div`
  display: flex;
  align-items: center;

  img {
    object-fit: contain;
    width: 3.5rem;
    height: 3.5rem;
    min-width: 3.3rem;
    max-width: 100%;
  }
`
